import { authRoles } from 'app/auth';

const navigationConfig = [
	{
		id: 'users',
		title: 'users',
		translate: 'FELHASZNÁLÓ',
		type: 'group',
		icon: 'apps',
		auth: [...authRoles.userAccount, ...authRoles.userRole],
		children: [
			{
				id: 'user-list',
				title: 'Hozzáférés',
				type: 'item',
				icon: 'person',
				url: '/user',
				auth: [...authRoles.userAccount]
			},
			{
				id: 'user-group',
				title: 'Felhasználói csoport',
				type: 'item',
				icon: 'person',
				url: '/user-group',
				auth: [...authRoles.userAccount]
			}
			// {
			//   id: 'dashboard-role',
			//   title: 'Jogkör',
			//   type: 'item',
			//   icon: 'perm_identity',
			//   url: '/dashboard-role',
			//   auth: [...authRoles.userRole]
			// }
		]
	},

	{
		id: 'upload',
		title: 'upload',
		translate: 'FELTOLTES',
		type: 'group',
		icon: 'apps',
		auth: [...authRoles.vizsgaztato],
		children: [
			{
				id: 'feltoltestesztlap-list',
				title: 'Feltöltés tesztlap',
				type: 'item',
				icon: 'person',
				url: '/feltoltestesztlap',
				auth: [...authRoles.vizsgaztato]
			},
			{
				id: 'feltoltesadatlap-list',
				title: 'Feltöltés adatlap',
				type: 'item',
				icon: 'person',
				url: '/feltoltesadatlap',
				auth: [...authRoles.vizsgaztato]
			}
		]
	},

	{
		id: 'correction',
		title: 'correction',
		translate: 'JAVITAS',
		type: 'group',
		icon: 'apps',
		auth: [...authRoles.szervezo],
		children: [
			// {
			// 	id: 'fejezet-list',
			// 	title: 'Fejezetek',
			// 	type: 'item',
			// 	icon: 'person',
			// 	url: '/fejezet',
			// 	auth: [...authRoles.szervezo]
			// },
			{
				id: 'vonalkodadatlap-list',
				title: 'Adatlap vonalkód megadása',
				type: 'item',
				icon: 'person',
				url: '/vonalkodadatlap',
				auth: [...authRoles.szervezo]
			},
			{
				id: 'vonalkodtesztlap-list',
				title: 'Tesztlap vonalkód megadása',
				type: 'item',
				icon: 'person',
				url: '/vonalkodtesztlap',
				auth: [...authRoles.szervezo]
			},
			{
				id: 'racstesztlap-list',
				title: 'Rács megadása',
				type: 'item',
				icon: 'person',
				url: '/racstesztlap',
				auth: [...authRoles.szervezo]
			},
			{
				id: 'tesztlapok-list',
				title: 'Tesztlapok',
				type: 'item',
				icon: 'person',
				url: '/tesztlapok',
				auth: [...authRoles.szervezo]
			},
			{
				id: 'parositasadatlap-list',
				title: 'Párosítás',
				type: 'item',
				icon: 'person',
				url: '/parositasadatlap',
				auth: [...authRoles.szervezo]
			}
		]
	},
	{
		id: 'question',
		title: 'question',
		translate: 'TESZTBANK',
		type: 'group',
		icon: 'apps',
		auth: [...authRoles.admin, ...authRoles.reviewer], // ⬅️ reviewer látja a csoportot
		children: [
			{
				id: 'feladat-csoport',
				title: 'Feladat csoportok',
				type: 'item',
				icon: 'person',
				url: '/feladat-csoport',
				auth: [...authRoles.admin]
			},
			{
				id: 'fejezet-list',
				title: 'Fejezetek',
				type: 'item',
				icon: 'person',
				url: '/fejezet',
				auth: [...authRoles.admin]
			},
			{
				id: 'esetleiras-list',
				title: 'Esetleírások',
				type: 'item',
				icon: 'person',
				url: '/esetleiras',
				auth: [...authRoles.admin]
			},
			{
				id: 'kerdes-list',
				title: 'Kérdések',
				type: 'item',
				icon: 'person',
				url: '/kerdes',
				auth: [...authRoles.admin, ...authRoles.reviewer] // ⬅️ reviewer ezt látja
			},
			{
				id: 'kerdes-velemeny',
				title: 'Kérdés vélemény',
				type: 'item',
				icon: 'person',
				url: '/kerdes-velemeny',
				auth: [...authRoles.admin]
			},
			{
				id: 'asszociacioskerdes-list',
				title: 'Asszociációs kérdések',
				type: 'item',
				icon: 'person',
				url: '/asszociacioskerdes',
				auth: [...authRoles.admin]
			}
		]
	},

	{
		id: 'vizsgak',
		title: 'vizsgak',
		translate: 'VIZSGÁK',
		type: 'group',
		auth: [...authRoles.admin],
		children: [
			{
				id: 'vizsga',
				title: 'Vizsga',
				type: 'item',
				icon: 'note',
				url: '/vizsga',
				auth: [...authRoles.admin]
			},
			{
				id: 'vizsga-feladatsor',
				title: 'Vizsgafeladatsor',
				type: 'item',
				icon: 'receipt',
				url: '/vizsga-feladatsor',
				auth: [...authRoles.admin]
			},
			{
				id: 'vizsgazo',
				title: 'Vizsgázó',
				type: 'item',
				icon: 'class',
				url: '/vizsgazo',
				auth: [...authRoles.admin]
			},
			{
				id: 'uzenet',
				title: 'Üzenet',
				type: 'item',
				icon: 'email',
				url: '/uzenet',
				auth: [...authRoles.admin]
			}
		]
	},

	{
		id: 'fm',
		title: 'fm',
		translate: 'TÁRHELY',
		type: 'group',
		auth: [...authRoles.admin],
		children: [
			{
				id: 'fm-storage',
				title: 'Megosztott mappák',
				type: 'item',
				icon: 'folder_shared',
				url: '/fm-storage',
				auth: [...authRoles.admin]
			}
		]
	}
];

export default navigationConfig;
